import * as React from 'react';
import { ReactSVG } from 'react-svg';
import { ISvgImageProps } from './SvgImage.types';

const SvgImage: React.FC<ISvgImageProps> = (props: ISvgImageProps) => {
  const { inAssetsPath, className, style, height, width } = props;

  return (
    <ReactSVG
      beforeInjection={svg => {
        const h = svg.getAttribute('height');
        const w = svg.getAttribute('width');
        svg.setAttribute('preserveAspectRatio', 'none');
        if (width) {
          svg.setAttribute('width', width);
        }
        if (height) {
          svg.setAttribute('height', height);
        }
        svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
      }}
      style={style}
      className={className}
      src={inAssetsPath}
    />
  );
};

export default SvgImage;
